// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1JvHz","inner":"Footer_inner__2hYOC"};